import React, { ReactNode } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

type AgentRegistryPageMountProps = {
  children: ReactNode;
};

export function AgentRegistryPageMount({
  children,
}: AgentRegistryPageMountProps): JSX.Element {
  const configApi = useApi(configApiRef);
  if (configApi.getOptionalString('plugins.agentRegistry.enabled') !== 'true') {
    return <></>;
  }
  return <>{children}</>;
}
